import { render } from "./ManageStock.vue?vue&type=template&id=648f2447"
import script from "./ManageStock.vue?vue&type=script&lang=js"
export * from "./ManageStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__